var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53388 7.64404L3.85879 9.31913C3.23319 9.94473 2.87343 10.796 2.88 11.6906C2.88658 12.5852 3.23847 13.4416 3.89375 14.0766C4.52877 14.7319 5.38536 15.0838 6.27983 15.0904C7.1947 15.0971 8.02577 14.7576 8.65141 14.132L10.3265 12.4569M12.4661 10.3582L14.1412 8.68314C14.7668 8.05753 15.1266 7.20631 15.12 6.3117C15.1134 5.41709 14.7615 4.56068 14.1062 3.92563C13.4714 3.29076 12.6149 2.93886 11.7203 2.93228C10.8257 2.92571 9.97437 3.26505 9.34874 3.89066L7.67364 5.56576M6.45983 11.4965L11.4851 6.47123",
    stroke: "#13213B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.a63c0ea20f7975d9a604e38679608151.svg";
export { ForwardRef as ReactComponent };